<template>
  <div class="identity-container">
    <Modal
      class="identity-modal"
      width="612"
      footer-hide
      v-model="modelIndex"
      @on-visible-change="visibleChange"
      :mask-closable = "false">
      <div slot="header">
        <div class="ivu-modal-header-inner">{{'请选择'+(flow_path == 0 ? '您的身份':'您感兴趣的领域')+'，让动脉橙更懂您'}}</div>
        <span @click="flow_path = 1" v-if="flow_path == 2"><i class="iconfont">&#xe646;</i>返回</span>
      </div>
      <div class="content">
        <Spin fix v-if="!finish">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div v-else>
          <Carousel v-if="finish_carousel" v-model="flow_path" arrow="never" dots="none" class="finish-carousel" >
            <CarouselItem>
              <div class="demo-carousel">
                <div class="carousel-item" :class="{'active': identity_id == item.id}" v-for="item in xuser_type" :key="item.id" @click="handleClickIdentity(item.id)">
                  <span>{{item.name}}</span>
                  <img :src="item.img_path | logo_show" class="bg"/>
                  <img :src="$store.state.static_img_url+'pic/select.png'" class="sel"/>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div class="tags">
                <div class="demo-carousel">
                  <div class="carousel-item" :class="{'active': active_level1 == item.id}" v-for="item in tags" :key="item.id" @click="handleClickLevel1(item.id)" v-if="item.children.length">
                    <span>{{item.name}}</span>
                    <img :src="$store.state.static_img_url + 'pic/tag-img-'+item.id+'.png'" class="bg"/>
                    <img :src="$store.state.static_img_url+'pic/select.png'" class="sel"/>
                  </div>
                </div>
                <div class="tag-list">
                  <div class="tag" v-for="item in level1to2" :key="item.id" :class="{'active': active_tag(item.id, subscribe_ids)}" @click="selectSub(item)">
                    <span>{{item.name}}</span>
                    <img :src="$store.state.static_img_url+'pic/select.png'" class="sel"/>
                    <i class="iconfont" v-if="item.children.length && !active_level2to3(item.id)">&#xe647;</i>
                    <em v-if="item.children.length && active_level2to3(item.id)">{{active_level2to3(item.id)}}</em>
                  </div>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div class="tag-level-2">
                <div class="tag-list">
                  <div class="tag" :class="{'active': active_tag(active_level2.id, subscribe_ids)}" @click="selectSub(active_level2)">
                    <span>{{active_level2.name}}</span>
                    <img :src="$store.state.static_img_url+'pic/select.png'" class="sel"/>
                  </div>
                </div>
                <div class="tag-list tag-list-2">
                  <div class="tag" v-for="item in active_level2.children" :key="item.id" :class="{'active': active_tag(item.id, subscribe_ids)}" @click="selectSub(item)">
                    <span>{{item.name}}</span>
                    <img :src="$store.state.static_img_url+'pic/select.png'" class="sel"/>
                  </div>
                </div>
              </div>
            </CarouselItem>
          </Carousel>
        </div>
        <div class="footer">
          <p class="button" @click="next" :class="{'on': button_state}">{{flow_path == 0 && subscribe.length == 0 ? '下一步' : '完成'}}</p>
          <p class="next" @click="jump">跳过</p>
          <!-- <p class="tip"><template v-if="flow_path == 0">您可以在个人中心-账户设置-进行修改</template><template v-else>您可以在个人中心-账户设置-进行修改</template></p> -->
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getMeta, updateUserIdentity, refreshUserInfo, subscribeList, addSubscribeMore } from '../service'
import Cookies from 'js-cookie'
// 0是选身份，1是选热门领域
export default {
  data() {
    return {
      modelIndex: false,
      refresh: false,
      xuser_type: [],
      recommend_tag_map: [],
      entity_ntag: [],
      flow_path: 0,
      finish: false,
      finish_carousel: false,
      // 身份
      identity_id: '',
      // 领域
      subscribe_ids: ['22', '23', '24'],
      active_level1: '21',
      active_level2: {}
    }
  },
  computed: {
    subscribe() {
      if (this.$store.state.attention.subscribe) {
        return this.$store.state.attention.subscribe.filter((item) => {return item.sub_type == '2'})
      } else {
        return []
      }
    },
    tags() {
      let arr1 = [],
        arr2 = this.recommend_tag_map.filter(item => item.pid != null && item.gpid == null),
        arr3 = this.recommend_tag_map.filter(item => item.pid != null && item.gpid != null)

      this.entity_ntag.map(item => {
        if (item.pid == null && item.gpid == null) {
          arr1.push(Object.assign(item, { children: [] }))
        }
      })

      arr2.map(item => {
        let index = arr1.findIndex(a => item.pid == a.id)
        if (index > -1) {
          arr1[index].children.push(Object.assign(item, { children: [] }))
        }
      })

      arr3.map(item => {
        let index1 = arr1.findIndex(a => item.gpid == a.id)
        if (index1 > -1) {
          let index2 = arr1[index1].children.findIndex(a => item.pid == a.id)
          if (index2 > -1) {
            arr1[index1].children[index2].children.push(item)
          }
        }
      })
      return arr1
    },
    level1to2() {
      let arr = []
      let index = this.tags.findIndex(prop => prop.id == this.active_level1)
        if (index > -1) {
          this.tags[index].children.map(item => {
            arr.push(item)
          })
        }
      return arr
    },
    active_tag() {
      return function(tag_id, active_arr) {
        let index = active_arr.findIndex(item => item == tag_id)
        return index > -1
      }
    },
    button_state() {
      if (this.flow_path == 0) {
        return this.identity_id != ''
      } else {
        return this.subscribe_ids.length > 0
      }
    },
    active_level2to3() {
      return function(tag_id) {
        let level3 = this.entity_ntag.filter(item => item.pid == tag_id)
        let len = 0
        this.subscribe_ids.map(item => {
          let index = level3.findIndex(prop => prop.id == item)
          if (index > -1) {
            len++
          }
        })
        return len > 9 ? '9+' : len
      }
    },
    version_cb() {
      return this.$store.state.version_cb
    }
  },
  props: ['selectIdentity', 'flow'],
  methods: {
    async getMeta() {
      let res = await getMeta({
        name: ['xuser_type','recommend_tag_map', 'entity_ntag']
      }, (error) => {this.$Message.error('元数据请求错误！')})
      if (res.status == 'success') {
        this.xuser_type = res.meta.xuser_type
        this.recommend_tag_map = res.meta.recommend_tag_map
        this.entity_ntag = res.meta.entity_ntag
        this.$nextTick(() => {
          this.finish = true
          setTimeout(() => {
            this.finish_carousel = true
          }, 500)
        })
      } else {
        this.$Message.error(res.message)
      }
    },
    handleClickIdentity(item_id) {
      this.identity_id = this.identity_id == item_id ? '' : item_id
    },
    handleClickLevel1(item_id) {
      this.active_level1 = item_id
      // let index = this.active_level1.indexOf(item_id)
      // if (index == -1) { // 新增
      //   this.active_level1.push(item_id)
      // } else { // 删除
      //   this.active_level1.splice(index, 1)
      // }
    },
    async next() { // 点击下一步
      if (this.flow_path == 0) { // 选身份
        if (!this.identity_id) {
          this.$Message.warning('亲，请选择您的身份，让动脉橙更懂您~');
          return
        }
        let res = await updateUserIdentity({
          user_key: this.$store.state.user_key,
          xuser_type_id: this.identity_id
        },(error) => {this.$Message.error('修改失败')})
        if (res.status == 'success') { // 成功之后修改用户信息
          let user_info = await refreshUserInfo({user_key: Cookies.get('user_key_'+this.$store.state.cookie_type)})
          if (user_info.status == 'success') {
            // Cookies.set('user', user_info.res[0])
            this.$store.commit('updateUser', user_info.res[0])
          }
          if(this.subscribe.length == 0) { // 如果用户没有关注过才要求关注
            this.flow_path = 1
          } else {
            this.refresh = true
            this.modelIndex = false
          }
        } else {
          this.$Message.error(res.message)
        }
        return
      } else { // 添加领域(刷新APP里面关注全局变量)
        if (!this.subscribe_ids.length) {
          this.$Message.warning('亲，请选择您感兴趣的领域，让动脉橙更懂你~');
          return
        }
        this.addSubscribeMore()
      }
    },
    visibleChange(val) {
      if (!val) {
        this.$store.commit('updateIdentity', 0)
        this.$emit('identitycancel', this.refresh)
        document.body.style.paddingRight = ''
        document.body.style.overflow = ''
      }
    },
    jump() { // 跳过
      if(this.flow_path == 0){
        if(this.subscribe.length == 0) { // 如果用户没有关注过才要求关注
          this.flow_path = 1
        } else {
          this.modelIndex = false
        }
      } else if(this.flow_path == 1){
        this.modelIndex = false
      }
    },
    selectSub(item) { // 点击领域
      if(item.children && item.children.length && this.flow_path != 2) {
        this.active_level2 = item
        this.flow_path = 2
      } else {
        let temp_index = this.subscribe_ids.indexOf(item.id)
        if (temp_index == -1) { // 新增
          this.subscribe_ids.push(item.id)
        } else { // 删除
          this.subscribe_ids.splice(temp_index, 1)
        }
      }
    },
    async addSubscribeMore() {
      let res = await addSubscribeMore({
        user_key: this.$store.state.user_key,
        sub_type: '2',
        sub_type_id_arr: this.subscribe_ids
      })
      if (res.status == 'success') {
        this.getSubscribeList()
        this.refresh = true
        this.modelIndex = false
      } else {
        this.$Message.error(res.message)
      }
    },
    async getSubscribeList() { // 更新关注领域
      let res = await subscribeList({user_key: this.$store.state.user_key},(error) => {
        console.log('请求错误！')
      })
      if(res.status == 'success') {
        this.$store.commit('updateFilter', {
          g_relation:res.g_relation,
          group:res.group,
          subscribe:res.subscribe
        })
      }
    }
  },
  watch: {
    selectIdentity(bl) {
      this.modelIndex = bl
      this.flow_path = this.flow ? this.flow : 0
    },
    version_cb(val) {
      if(val) {
        this.getMeta()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.ivu-spin
  color: rgba(250, 122, 80, 1)
  background-color #fff
.identity-modal
  >>>.ivu-modal-wrap
    display flex
    align-items center
    justify-content center
  >>>.ivu-modal
    top auto
    overflow hidden
    .ivu-modal-content
      border-radius: 0;
      .ivu-modal-header
        padding: 25px 20px 20px;
        border-bottom: 0;
        position relative
        .ivu-modal-header-inner
          color: #333333;
          font-size: 20px;
          font-weight normal
          text-align center
        span
          position absolute
          font-size 14px
          font-weight 400
          color rgba(51,51,51,1)
          line-height 1
          left 16px
          top 16px
          cursor pointer
          i
            line-height 1
            font-size 12px
            color #000
            display inline-block
            vertical-align top
            margin 1px 1px -1px -2px
          &:hover
            color #FA7A50
            i
              color #FA7A50
      .ivu-modal-body
        padding 0;
        >>> .finish-carousel
          height: 286px;
          width: 612px;
      .ivu-modal-close
        top: 14px;
        .ivu-icon-ios-close
          color: #dddddd;
          &:hover
            color: rgba(250, 122, 80, 1);

    .content
      position: relative;
      min-height: 366px;
      
      .footer
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        padding: 20px 16px;
        p
          cursor: pointer;
        .button
          width:150px;
          height:40px;
          margin: 0 auto;
          border-radius:20px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          background-color #D9D9D9
          color #fff
          &.on
            background-color #FA7A50
            &:hover
              background-color rgba(252, 156, 124, 1)
        .next
          font-size: 14px;
          color: #CCCCCC;
          position: absolute;
          right: 16px;
          top: 30px;
      .demo-carousel
        display: grid;
        grid-template-columns: repeat(5, 104px);
        grid-gap: 12px;
        padding: 0 22px;
        overflow-y: auto;
        max-height: 286px;
        width 612px
        &::-webkit-scrollbar-track
          border: 0;
          background-color: transparent !important;
        &::-webkit-scrollbar
          width: 6px;
          background-color: transparent !important;
        &::-webkit-scrollbar-thumb
          border-radius: 6px;
          background-color: #B1B1B1
        .carousel-item
          height: 104px;
          position: relative
          cursor: pointer
          border 2px solid #fff
          &:before
            content ''
            position absolute
            top 0
            bottom 0
            right 0
            left 0
            background linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%)
            opacity .7
            z-index 2
          .bg
            width 100%
            height 100%
            display block
          span
            position absolute
            left 50%
            top 50%
            width 100%
            text-align center
            padding 0 10px
            transform translate(-50%, -50%)
            color: #fff
            line-height:18px
            font-weight:600
            z-index 3
            font-size 14px
          .sel
            width:20px
            height:20px
            position absolute
            right 0
            bottom 0
            z-index 4
            display none
          &:hover
            border-color #FA7A50
          &.active
            border-color #FA7A50
            .sel
              display block
      .tags
      .tag-level-2
        overflow-y: auto;
        max-height: 286px;
        &::-webkit-scrollbar-track
          border: 0;
          background-color: transparent !important;
        &::-webkit-scrollbar
          width: 6px;
          background-color: transparent !important;
        &::-webkit-scrollbar-thumb
          border-radius: 6px;
          background-color: #B1B1B1
        .demo-carousel
          overflow visible
      .tag-list
        margin 16px 0 0 24px
        width 564px
        padding 16px 6px 6px 16px
        background-color #F5F5F5
        display flex
        flex-wrap wrap
        .tag
          background-color #fff
          color #333
          margin 0 10px 10px 0
          line-height 1
          padding 10px
          font-style 14px
          border 1px solid #fff
          cursor pointer
          position relative
          .sel
            width:12px
            height:12px
            position absolute
            right 0
            bottom 0
            z-index 4
            display none
          i
            font-size 12px
            color #AAAAAA
            display inline-block
            vertical-align top
            margin: 1px -4px -1px 2px
          em
            width 14px
            height 14px
            display inline-block
            vertical-align top
            margin: -1px 0 -1px 4px
            background-color #FA7A50
            color #fff
            border-radius 50%
            text-align center
            line-height 14px
          &:hover
            border-color #FA7A50 !important
          &.active
            border-color #FA7A50 !important
            .sel
              display block
      .tag-level-2
        max-height: 366px
        .tag-list
          margin 0 0 0 24px
          width 564px
          padding 0
          background-color #fff
          .tag
            border-color #D5D5D5
            color: #666666
        .tag-list-2
          border-top 1px dashed #E9E9E9
          padding-top 16px
          margin-top 6px
</style>
